import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from "react";
import { Tab } from "@parkschannel/ui";
import { CounterTabsButton } from "./CounterTabsButton";
import { CounterTab } from "./CounterTab";
import classNames from "classnames";
export const CounterTabGroup = (param)=>{
    let { scroll ="horizontal" , items , renderTab , extractId , extractLabel , extractTotal , ...props } = param;
    const tabs = useMemo(()=>items.map((item)=>/*#__PURE__*/ _jsx(CounterTab, {
                tabId: extractId(item),
                children: renderTab(item)
            }, extractId(item))), [
        items
    ]);
    const buttons = useMemo(()=>items.map((item)=>/*#__PURE__*/ _jsx(CounterTabsButton, {
                tabId: extractId(item),
                total: extractTotal(item),
                className: classNames({
                    "h-[44px]": scroll === "vertical"
                }),
                children: extractLabel(item)
            }, extractId(item))), [
        items
    ]);
    return /*#__PURE__*/ _jsxs(Tab.TabGroup, {
        ...props,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: classNames("relative bg-neutral-100 w-full rounded-xl", {
                    "h-[59px]": scroll === "horizontal",
                    "h-fit": scroll === "vertical"
                }),
                children: /*#__PURE__*/ _jsx("div", {
                    className: classNames("w-full flex gap-2 px-2 pt-2 pb-3", {
                        "overflow-x-auto absolute top-0 left-0": scroll === "horizontal",
                        "overflow-y-auto flex-wrap items-start  max-h-[120px] lg:max-h-[190px]": scroll === "vertical"
                    }),
                    children: buttons
                })
            }),
            tabs
        ]
    });
};
